<script>
import {Icon} from '@iconify/vue/dist/iconify';

/* COMPOSANTS */
import AkInputSwitch from '@components/input/AkInputSwitch';
import AkCalendar from '@components/input/AkCalendar';
import AkAccountAutocomplete from '@components/general/AkAccountAutocomplete';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@mixins/sidebarMixin';

/* SERVICES */

export default {
  components: {
    AkAccountAutocomplete,
    AkCalendar,
    AkInputSwitch,
    Icon,
  },
  mixins: [utilsMixin, sidebarMixin],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      if (this.$refs.accountAutocomplete) this.$refs.accountAutocomplete.reset();
      this.callback[1]();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <h2>Filtrer</h2>
  <form class="d-flex flex-column" style="row-gap: 16px" @submit.prevent="search">
    <AkAccountAutocomplete
      v-model="currentValue.num"
      ref="accountAutocomplete"
      :inline="true"
      :placeholder="$t('accounting.number')"
      class-name="flex-1" />

    <AkCalendar
      v-model="currentValue.dateFrom"
      :label="$t('visitor_tax.date_from')"
      date-format="dd/mm/yy"
      selection-mode="single"
      :title="$t('visitor_tax.filter_date')"
      :inline="true"
      :display-label="false"
      class-name="flex-1" />
    <AkCalendar
      v-model="currentValue.dateTo"
      :label="$t('visitor_tax.date_to')"
      date-format="dd/mm/yy"
      selection-mode="single"
      :title="$t('visitor_tax.filter_date')"
      :inline="true"
      :display-label="false"
      class-name="flex-1" />
    <AkInputSwitch
      v-model="currentValue.displayReservations"
      :label="$t('balance.show_resa_account')"
      :inline="true"
      :labelBefore="false"
      class-name="flex-1" />
    <AkInputSwitch
      v-model="currentValue.displayTerminatedMandats"
      :label="$t('balance.show_mandats_terminated')"
      :inline="true"
      :labelBefore="false"
      class-name="flex-1" />

    <div class="d-flex flex-row">
      <button class="btn btn-primary btn-search flex-1" type="submit">
        {{ this.$t('visitor_tax.filter') }}
      </button>
      <Icon
        v-on:click="this.reset()"
        class="pointer"
        icon="basil:cross-outline"
        :style="{fontSize: '50px', width: '50px !important'}" />
    </div>
  </form>
</template>
